<template>
    <div class="ai-data-field-row flex items-center gap-3 rounded-lg border px-3 py-2.5">
        <div class="min-w-0 flex-1">
            <div class="flex items-baseline gap-2 min-w-0">
                <span class="text-sm font-semibold truncate">{{ title }}</span>
                <div
                    v-if="showKey"
                    class="ai-data-field-row__key text-main-xs text-gray-500 truncate"
                >
                    {{ field.key }}
                </div>
            </div>
            <p
                v-if="field.group"
                class="text-main-xs text-gray-500"
            >
                {{ field.group }}
            </p>
        </div>

        <button
            type="button"
            class="ai-data-field-row__remove shrink-0 flex-center rounded"
            :title="String(t('widget.aiBuilder.dataFields.remove'))"
            @click="$emit('remove', field.key)"
        >
            <i class="vc-icon-close" />
        </button>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { IAiDataField } from '@/types/widgetParameters'

const { t } = useI18n()

const props = defineProps<{
    field: IAiDataField
}>()

defineEmits<{
    (e: 'remove', questionKey: string): void
}>()

const title = computed(() => props.field.title || props.field.key)

const showKey = computed(() => props.field.title && props.field.title !== props.field.key)
</script>

<style scoped lang="scss">
.ai-data-field-row {
    border-color: var(--ui-lines);
    background: var(--main-bg);

    &__key {
        font-family: monospace;
    }

    &__remove {
        width: 24px;
        height: 24px;
        color: var(--steel);

        &:hover {
            color: var(--primary-actions);
        }
    }
}
</style>
